import { newSpecPage } from '@stencil/core/testing';
import { SallaAppsIcons } from '../salla-apps-icons';

describe('salla-apps-icons', () => {
  it('renders', async () => {
    const page = await newSpecPage({
      components: [SallaAppsIcons],
      html: `<salla-apps-icons></salla-apps-icons>`,
    });
    expect(page.root).toEqualHtml(`
      <salla-apps-icons>
        <mock:shadow-root>
          <slot></slot>
        </mock:shadow-root>
      </salla-apps-icons>
    `);
  });
});
